
const arr= [
    {
        title: "Social",
        child: [
            {
                name:"Find Coaches",
                route:"/social/find-coach"
            },
            {
                name:"Challenge Trainer",
                route:"/social/challenge-trainer"
            },
            {
                name:"My Friends",
                route:"/social/friends"
            },
        ]
    },
    {
        title: "Extras",
        child: [
            {
                name:"Badges",
                route:"/extras/badges"
            },
            {
                name:"Fishery",
                route:"/extras/fishery"
            },
            {
                name:"Pokedex",
                route:"/extras/pokedex"
            },
        ]
    },
    {
        title: "Assistance",
        child: [
            {
                name:"Calculator",
                route:"/assistance/calculator"
            },
            {
                name:"Pockemon Guide",
                route:"/assistance/pokemon-guide"
            },
            {
                name:"Pokemon Judge",
                route:"/assistance/pokemon-judge"
            },
        ]
    },
    {
        title: "Others",
        child: [
            {
                name:"Buy House",
                route:"/others/buy-house"
            },
            {
                name:"Pokemon Specialist",
                route:"/others/pokemon-specialist"
            },
            {
                name:"General Statistics",
                route:"/others/general-statistics"
            },
        ]
    },

]

export const home_menu=[
    {
        name:"Gold Market",
        route:"/gold-market",
    },
    {
        name:"City",
        route:"/city",
    },
    {
        name:"Classification",
        route:"/classification",
    },
    {
        name:"Pokemon Box",
        route:"/pokemon-box",
    },
    {
        name:"Backpack",
        route:"/backpack",
    },
    {
        name:"Map",
        route:"/map",
    },
    {
        name:"NPCs",
        route:"/npcs",
    },
]
export default arr
